/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

export { default as PageProgress } from './PageProgress';
export { default as RouterProgress } from './RouterProgress';
